import script from "./FileContainerFile.vue?vue&type=script&setup=true&lang=js"
export * from "./FileContainerFile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__